<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.show_product_category") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #266db0">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <div v-if="data.image.path">
            <!-- Display image -->
            <div class="preview-container text-center my-3">
              <video
                v-if="data.image.path.endsWith('mp4')"
                :src="data.image.path"
                controls
                autoplay
                loop
              ></video>
              <img v-else :src="data.image.path" alt="Advertisement Image" />
            </div>
          </div>

          <!-- Start:: Ar Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.nameAr"
            disabled
          />
          <!-- End:: Ar Name Input -->

          <!-- Start:: En Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.nameEn"
            disabled
          />
          <!-- End:: En Name Input -->

          <!-- Start:: Provider Input -->
          <base-select-input
            col="12"
            :optionsList="allProviders"
            :placeholder="$t('SIDENAV.OffersManagement.providerName')"
            v-model="data.selectedProviders"
            multiple
            disabled
          />
          <!-- End:: Provider Input -->

          <!-- Start:: Activation Status Input -->
          <base-select-input
            col="12"
            :optionsList="activationStatuses"
            :placeholder="$t('PLACEHOLDERS.status')"
            v-model="data.active"
            disabled
          />
          <!-- End:: Activation Status Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowProductCategories",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        nameAr: null,
        nameEn: null,
        selectedProviders: [],
        active: null,
      },
      // End:: Data Collection To Send

      allProviders: [], // This should be populated with the list of providers
      activationStatuses: [
        { id: 1, name: this.$t("PLACEHOLDERS.active"), value: 1 },
        { id: 0, name: this.$t("PLACEHOLDERS.notActive"), value: 0 },
      ],
    };
  },

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    // Start:: Get Data
    async getData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `categories/${this.$route.params.id}`,
        });
        // Start:: Set Data
        this.data.image.path = res.data.data?.Category.file_path;
        this.data.nameAr = res.data.data?.Category.name_ar;
        this.data.nameEn = res.data.data?.Category.name_en;
        this.data.selectedProviders = res.data.data?.Category.users;
        this.data.active = {
          id: res.data.data?.Category.is_active ? 1 : 0,
          name: res.data.data?.Category.is_active ? this.$t("PLACEHOLDERS.active") : this.$t("PLACEHOLDERS.notActive"),
          value: res.data.data?.Category.is_active
        };
        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data
  },

  async created() {
    // Start:: Fire Methods
    this.getData();
    // End:: Fire Methods
  },
};
</script>
